<template>
  <div class="rank-settings">
    <div class="rank-tabs">
      <button v-for="t in tabs" :key="t.key"
              :class="['rank-tab', 'rank-tab--' + t.key, {'is-active': active === t.key, 'is-unused': t.unused}]"
              :title="t.unused ? 'Đang tạm ẩn trên website, chưa dùng' : ''"
              @click="active = t.key">
        <i class="bi" :class="t.icon"></i> {{ t.title }}
        <span v-if="t.unused" class="rank-tab__tag">chưa dùng</span>
      </button>
    </div>
    <!-- mỗi tab một bộ cấu hình riêng (có thanh lưu riêng) -->
    <template v-for="t in tabs" :key="t.key">
      <SystemConfigSettings v-if="active === t.key" :groups="t.groups" :intro="t.intro"
                            :class="{'is-unused-tab': t.unused}"/>
    </template>
  </div>
</template>

<script>
import SystemConfigSettings from "@/components/settings/SystemConfigSettings.vue";
import {RANKING_TABS} from "@/components/settings/rankingConfig";

export default {
  name: 'RankingSettings',
  components: {SystemConfigSettings},
  data() {
    return {tabs: RANKING_TABS, active: RANKING_TABS[0].key};
  },
};
</script>

<style scoped>
.rank-settings { display: flex; flex-direction: column; gap: 16px; }
.rank-tabs { display: flex; flex-wrap: wrap; gap: 8px; }
.rank-tab {
  --tc: #eb3349;
  display: inline-flex; align-items: center; gap: 8px; height: 40px; padding: 0 18px;
  border: 1px solid #e4e6ef; border-radius: 10px; background: #fff;
  color: #5e6278; font-size: 14px; font-weight: 600; transition: all .15s ease;
}
.rank-tab i { color: var(--tc); }
.rank-tab:hover { border-color: var(--tc); }
.rank-tab.is-active { background: var(--tc); border-color: var(--tc); color: #fff; }
.rank-tab.is-active i { color: #fff; }
.rank-tab--favorite { --tc: #e8458b; }
.rank-tab--hard { --tc: #f08c00; }
/* tab chưa dùng: xám hẳn */
.rank-tab.is-unused { --tc: #a1a5b7; background: #f5f5f7; color: #a1a5b7; border-style: dashed; }
.rank-tab.is-unused.is-active { background: #a1a5b7; border-color: #a1a5b7; border-style: solid; color: #fff; }
.rank-tab__tag {
  padding: 1px 6px; border-radius: 6px; background: rgba(0, 0, 0, .06);
  font-size: 11px; font-weight: 600;
}
.rank-tab.is-active .rank-tab__tag { background: rgba(255, 255, 255, .25); }
/* nội dung tab chưa dùng: xám toàn bộ */
.is-unused-tab :deep(.syscfg__section),
.is-unused-tab :deep(.syscfg__intro) {
  filter: grayscale(1);
  opacity: .65;
}
.is-unused-tab :deep(.syscfg__section) { background: #f7f7f9; }
</style>
